import React, { useEffect, useContext, useRef } from 'react';

import {
    Container,
    Typography,
    Grid,
    Button
} from '@material-ui/core';

import {
} from '../../common';

import {
    LoginForm
} from './components';

import { PageProvider, PageContext } from './PageContext';
import { AuthContext } from '../../contexts/AuthContext';
import { NavContext, NavRoutes } from '../../contexts/NavContext';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

const PageContent = (props) => {
    const classes = useStyles();

    const {
        state,
        isBusy,
        setIsBusy,
        loginAsync
    } = useContext(PageContext);

    const {
        state: { isAuthenticated }
    } = useContext(AuthContext);

    const {
        navigateTo
    } = useContext(NavContext);

    const {
    } = state;

    // const formRef = useRef();
    // const loginClickHandler = (e) => {
    //     if (formRef.current) {
    //         formRef.current.handleSubmit();
    //     }
    // }    

    const loginFormSubmitHandler = async (values, done) => {
        setIsBusy({ logginIn: true });
        const success = await loginAsync({ ...values });
        if (success) {
            navigateTo(NavRoutes.Home);
        }
        done();
        setIsBusy({ logginIn: false });
    }

    useEffect(() => {
        if (isAuthenticated) {
            navigateTo(NavRoutes.Home);
        }
    }, []);

    return (
        <Container maxWidth="xs" className={classes.root}>
            <LoginForm
                // formRef={formRef}
                disabled={isBusy()}
                onSubmit={loginFormSubmitHandler}
            />
        </Container>
    );
}

export const LoginPage = () => {

    return (
        <PageProvider>
            <PageContent />
        </PageProvider>
    );
}